module.exports = __webpack_public_path__ + "media/components/src/assets/images/top_img/catch-e35eb427bd6984f44e9bb12cd1c8edb4.webp";